module.exports = __webpack_public_path__ + "c6dfb70e4f54aea261afd655b951d751.svg";